import * as React from 'react';
const Minus = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 14 4"
		fill="none"
		{...props}
	>
		<path fill="#fff" d="M0 0h14v4H0z" />
	</svg>
);
export default Minus;
